import React, { FunctionComponent } from 'react';
import { Typography } from '@mui/material';
import cx from 'classnames';
import useStyles from './ServiceSectionLayout.styles';

interface IProps{
  title: string | React.ReactElement;
  testId?: string;
  customClass?: string;
  required?: boolean;
}

const ServiceSectionLayout: FunctionComponent<IProps> = ({
  children,
  title,
  testId,
  customClass = '',
  required = false,
}) => {
  const classes = useStyles();
  return (
    <>
      <Typography variant="h2" data-testid={`${testId}__title`}>
        {title}
        {required && <span className={classes.required}>*</span>}
      </Typography>
      <div
        className={cx(classes.container, {
          [customClass]: customClass,
        })}
      >
        {children}
      </div>
    </>
  );
};

export default ServiceSectionLayout;
